import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { useReducer } from 'react';
import pickBy from 'lodash.pickby';
import { DEFAULT_CONFIG } from '../../model/config/default';
import { ConfigContext } from './context';
import { configReducer } from './reducer';
/**
 * We strip supplied config of undefined fields because it can easily break TS assumptions.
 *
 * Illustrative example:
 *
 * type FullConf = { something: string }
 * type PartConf = Partial<FullConf>
 *
 * const defaultConf: FullConf = { something: 'default' }
 * const suppliedConf: PartConf = { something: undefined }
 * const conf: FullConf = {...defaultConf, ...suppliedConf}
 * conf.something.toString() // OK according to TS, breaks on runtime.
 */
/**
 * @internal Intended for internal use - use it on your own risk
 */
var noUndefined = function noUndefined(x) {
  return x !== undefined;
};
export function ConfigProvider(_ref) {
  var config = _ref.config,
    children = _ref.children;
  var _a;
  var configWithDefaults = Object.assign(Object.assign(Object.assign({}, DEFAULT_CONFIG), pickBy(config, noUndefined)), {
    bufferGasLimitPercentage: undefined,
    gasLimitBufferPercentage: (_a = config.gasLimitBufferPercentage) !== null && _a !== void 0 ? _a : config.bufferGasLimitPercentage,
    notifications: Object.assign(Object.assign({}, DEFAULT_CONFIG.notifications), pickBy(config.notifications, noUndefined))
  });
  var _useReducer = useReducer(configReducer, configWithDefaults),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    reducedConfig = _useReducer2[0],
    dispatch = _useReducer2[1];
  return _jsx(ConfigContext.Provider, {
    value: {
      config: reducedConfig,
      updateConfig: dispatch
    },
    children: children
  });
}